// extracted by mini-css-extract-plugin
module.exports = {"bgimg":"ComingSoon_bgimg__1uimG","middle":"ComingSoon_middle___XCeS"};